import { useState } from 'react'
import { IconSprite } from './components/IconSprite'
import { Preloader } from './components/Preloader'
import { Header } from './components/Header'
import { Hero } from './components/Hero'
import { Value } from './components/Value'
import { Platforms } from './components/Platforms'
import { Social } from './components/Social'
import { Eco } from './components/Eco'
import { Plans } from './components/Plans'
import { About } from './components/About'
import { Contact } from './components/Contact'
import { Footer } from './components/Footer'
import { WhatsAppFloat } from './components/WhatsAppFloat'

import { usePreloader } from './hooks/usePreloader'
import { useReveal } from './hooks/useReveal'
import { useHeaderScroll } from './hooks/useHeaderScroll'
import { useTilt } from './hooks/useTilt'
import { useMagnetic } from './hooks/useMagnetic'
import { useSmoothScroll } from './hooks/useSmoothScroll'

export default function App() {
  const [menuAberto, setMenuAberto] = useState(false)

  usePreloader()
  useReveal()
  useTilt()
  useMagnetic()
  useSmoothScroll()
  const { grudado, escondido, mostrarWhats } = useHeaderScroll(menuAberto)

  return (
    <>
      <Preloader />
      <IconSprite />

      <a className="skip" href="#conteudo">Pular para o conteúdo</a>

      <Header
        grudado={grudado}
        escondido={escondido}
        menuAberto={menuAberto}
        setMenuAberto={setMenuAberto}
      />

      <main id="conteudo">
        <Hero />
        <Value />
        <Platforms />
        <Social />
        <Eco />
        <Plans />
        <About />
        <Contact />
      </main>

      <Footer />
      <WhatsAppFloat visivel={mostrarWhats} />
    </>
  )
}
